var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg00327IconServiceAzureVirtualDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "e9a2b8bf-efad-4e15-89f0-635373400131",
    cx: 9,
    cy: 9,
    r: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#198ab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#1a8cb5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#1c94bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    stopColor: "#21a1c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#27b4d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#2fccee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32d4f5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "faeec9e4-44b9-413a-8332-867d334dcda2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "url(#e9a2b8bf-efad-4e15-89f0-635373400131)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 7.321,
    fill: "#005ba1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.1,9.937,6.266,7.125a.507.507,0,0,0-.709,0L5.2,7.48a.469.469,0,0,0-.143.337.476.476,0,0,0,.141.339l2.132,2.122L5.152,12.441a.473.473,0,0,0,0,.676l.361.355a.507.507,0,0,0,.709,0L9.1,10.612a.475.475,0,0,0,.141-.338A.468.468,0,0,0,9.1,9.937Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.755,7.678a.475.475,0,0,0,.141.338l2.88,2.859a.507.507,0,0,0,.709,0l.361-.356a.469.469,0,0,0,.143-.337.475.475,0,0,0-.141-.338L10.674,7.682l2.132-2.123a.475.475,0,0,0,.141-.338.469.469,0,0,0-.143-.337l-.361-.356a.507.507,0,0,0-.709,0L8.9,7.34A.472.472,0,0,0,8.755,7.678Z",
    fill: "#f2f2f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg00327IconServiceAzureVirtualDesktop);
export default __webpack_public_path__ + "static/media/00327-icon-service-Azure-Virtual-Desktop.acf24d496a3be8ec1d4d4301e46a5a3d.svg";
export { ForwardRef as ReactComponent };